 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import ALSOBYMARGERYALLINGHAM from '@/components/alsobymargeryallingham'
 import LOVE_1 from '@/components/love_1'
 import VOL001 from '@/components/vol001'
 import MYSTERYWRITERINTHEBOX from '@/components/mysterywriterinthebox'
 import VOL001THECASEISALTERED from '@/components/vol001thecaseisaltered'
 import VOL001MYFRIENDMRCAMPION from '@/components/vol001myfriendmrcampion'
 import VOL001THEDOGDAY from '@/components/vol001thedogday'
 import VOL001THEWINDGLASS from '@/components/vol001thewindglass'
 import VOL001THEBEAUTYKING from '@/components/vol001thebeautyking'
 import VOL001THEBLACKTENT from '@/components/vol001theblacktent'
 import VOL001SWEETANDLOW from '@/components/vol001sweetandlow'
 import VOL001ONCEINALIFETIME from '@/components/vol001onceinalifetime'
 import VOL001THEKERNELOFTRUTH from '@/components/vol001thekerneloftruth'
 import VOL001HAPPYCHRISTMAS from '@/components/vol001happychristmas'
 import VOL001THEWISDOMOFESDRAS from '@/components/vol001thewisdomofesdras'
 import VOL001THECURIOUSAFFAIRINNUTROW from '@/components/vol001thecuriousaffairinnutrow'
 import VOL001WHATTODOWITHANAGEINGDETECTIVE from '@/components/vol001whattodowithanageingdetective'
 import LOVE_2 from '@/components/love_2'
 import VOL002 from '@/components/vol002'
 import VOL002TALLSTORY from '@/components/vol002tallstory'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import VOL001COPYRIGHT from '@/components/vol001copyright'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/alsobymargeryallingham",
 			"name" : "alsobymargeryallingham",
 			"component" : ALSOBYMARGERYALLINGHAM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/vol001",
 			"name" : "vol001",
 			"component" : VOL001
 		},
 		{
 			"path" : "/mysterywriterinthebox",
 			"name" : "mysterywriterinthebox",
 			"component" : MYSTERYWRITERINTHEBOX
 		},
 		{
 			"path" : "/vol001thecaseisaltered",
 			"name" : "vol001thecaseisaltered",
 			"component" : VOL001THECASEISALTERED
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js